import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.MasksConfig;

export const statusSelector = createSelector(rootSelector, (masksConfig) => masksConfig.status);

export const errorSelector = createSelector(rootSelector, (masksConfig) => masksConfig.error);

const masksConfigSelector = createSelector(rootSelector, (masksConfig) => masksConfig.data);

export default {
  statusSelector,
  errorSelector,
  masksConfigSelector,
};
